import * as XLSX from 'xlsx';
import { saveAs } from 'file-saver';

// تعریف نوع داده‌ها
interface DataRow {
  [key: string]: any;
}

// تابع برای تبدیل داده‌ها به متن
const convertToText = (value: any): string => {
  if (Array.isArray(value)) {
    return value.map(convertToText).join(', ');
  } else if (typeof value === 'object' && value !== null) {
    return Object.entries(value).map(([key, val]) => `${key}: ${convertToText(val)}`).join(', ');
  }
  return String(value);
};

// تابع برای تبدیل داده‌ها به اکسل
const exportToExcel = (data: DataRow[], fileName: string): void => {
  // تبدیل داده‌ها به فرمت قابل قبول برای اکسل
  const formattedData = data.map(row => {
    const newRow: DataRow = {};
    for (const key in row) {
      newRow[key] = convertToText(row[key]);
    }
    return newRow;
  });

  // ایجاد یک ورک‌شیت از داده‌ها
  const ws = XLSX.utils.json_to_sheet(formattedData);
  
  // ایجاد یک ورک‌بوک و اضافه کردن ورک‌شیت به آن
  const wb = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(wb, ws, "Sheet1");
  
  // ایجاد فایل اکسل و دانلود آن
  const excelBuffer = XLSX.write(wb, { bookType: 'xlsx', type: 'array' });
  const dataBlob = new Blob([excelBuffer], { type: 'application/octet-stream' });
  saveAs(dataBlob, `${fileName}.xlsx`);
};

// تابع برای تبدیل داده‌ها به PDF


// صادرات توابع به صورت نام‌گذاری شده
export { exportToExcel };


// import * as XLSX from 'xlsx';
// import { saveAs } from 'file-saver';

// // تعریف نوع داده‌ها
// interface DataRow {
//   [key: string]: any;
// }

// const exportToExcel = (data: DataRow[], fileName: string): void => {
//   // ایجاد یک ورک‌شیت از داده‌ها
//   const ws = XLSX.utils.json_to_sheet(data);

//   // ایجاد یک ورک‌بوک و اضافه کردن ورک‌شیت به آن
//   const wb = XLSX.utils.book_new();
//   XLSX.utils.book_append_sheet(wb, ws, "Sheet1");

//   // ایجاد فایل اکسل و دانلود آن
//   const excelBuffer = XLSX.write(wb, { bookType: 'xlsx', type: 'array' });
//   const dataBlob = new Blob([excelBuffer], { type: 'application/octet-stream' });
//   saveAs(dataBlob, `${fileName}.xlsx`);
// };

// export default exportToExcel